const allowedOrigins = [
  'https://deposits-bank-reco-widget.qa.bankrate.com',
  'https://deposits-bank-reco-widget.bankrate.com'
]

// Checks if origin starts with any of the allowed origins.
export const isOriginAllowed = origin =>
  allowedOrigins.some(allowedOrigin => origin.startsWith(allowedOrigin))

export const isObject = val => val !== null && typeof val === 'object'

const getMessageTargetOrigin = () => {
  if (window.env === 'local') return '*'
  if (['qa', 'staging'].includes(window.env))
    return 'https://deposits-bank-reco-widget.qa.bankrate.com'
  return 'https://deposits-bank-reco-widget.bankrate.com'
}

export const sendMessage = message => {
  const iFrame = document.getElementById('deposits-reco-widget')

  if (!iFrame) {
    console.error('iFrame with id, "deposits-reco-widget", not found.')
    return
  }

  iFrame.contentWindow.postMessage(message, getMessageTargetOrigin())
}
